import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "./SpaceDialogAction";

const DialogNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties = ({
	dialog
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title="No se puede editar las sanciones de todos los alumnos"
			content="Actualmente hay más de un alumno con una sanción distinta.">
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogNotUpdatePenaltyBecauseStudentsHaveDiferentPenalties;